// Mock data for The Dillon Blueprint coaching website

export const heroData = {
  headline: "Build the Complete Athlete",
  subheadline: "Basketball • Strength • Fat Loss • Mindset • Discipline",
  description: "The Dillon Blueprint helps athletes and individuals develop their skills, build strength, improve body composition, and strengthen their mindset through structured training systems and intentional coaching.",
  primaryCTA: "Train With Me",
  secondaryCTA: "Book A Session",
  tertiaryCTA: "Explore Programs",
  heroImage: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/hkujxqll_hero%20section.jpeg",
  trustIndicators: [
    { value: "NCAA D1 +", label: "Professional Basketball Experience" },
    { value: "100+", label: "Athletes Coached" },
    { value: "Complete", label: "Athlete Development" }
  ]
};

export const socialProofData = {
  metrics: [
    { value: "100+", label: "Athletes Coached" },
    { value: "6+", label: "Month Programs" },
    { value: "Complete", label: "Development System" },
    { value: "Real", label: "Transformation Results" }
  ]
};

export const chooseYourPathData = [
  {
    id: 1,
    icon: "🏀",
    title: "Basketball Development",
    description: "For athletes who want to improve their skills, decision making, and performance on the court.",
    focus: [
      "Shooting development",
      "Ball handling",
      "Game IQ",
      "Skill training"
    ],
    cta: "Start Basketball Training"
  },
  {
    id: 2,
    icon: "💪",
    title: "Strength & Body Transformation",
    description: "For athletes or individuals who want to build strength, lose fat, and improve body composition.",
    focus: [
      "Strength training",
      "Fat loss",
      "Mobility",
      "Nutrition guidance"
    ],
    cta: "Start Fitness Coaching"
  },
  {
    id: 3,
    icon: "🧠",
    title: "Mindset & Discipline",
    description: "For individuals who want to develop stronger habits, discipline, and mental resilience.",
    focus: [
      "Habit building",
      "Confidence",
      "Mental clarity",
      "Personal accountability"
    ],
    cta: "Explore Mindset Coaching"
  },
  {
    id: 4,
    icon: "📅",
    title: "Book A Session",
    description: "For people who want to work directly with Alou through private sessions, consultations, or group workouts.",
    focus: [
      "Private sessions",
      "Group training",
      "Coaching calls"
    ],
    cta: "Book A Session"
  }
];

export const servicesData = [
  {
    id: 1,
    title: "Elite Basketball Training",
    description: "Develop the skills, decision-making, and composure required to perform at a high level. Training sessions focus on building complete players through intentional skill work and game-based development.",
    image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/wfabd3nd_basketball%20trainig%20pic.jpeg",
    focusAreas: [
      "Shooting mechanics and scoring development",
      "Footwork and finishing",
      "Ball handling and shot creation",
      "Game-based decision making",
      "Nervous system regulation under pressure",
      "Constraint-led game scenarios"
    ],
    pricing: {
      packages: [
        {
          name: "Single Session",
          price: "$45",
          description: "Per session"
        },
        {
          name: "10 Sessions Package",
          price: "$350",
          description: "Save with bulk sessions"
        },
        {
          name: "Private Training",
          price: "$360",
          description: "4 workouts package"
        }
      ]
    },
    cta: "Book Training"
  },
  {
    id: 2,
    title: "Online Strength & Fitness Coaching",
    description: "Build strength, improve mobility, and develop consistent habits through structured online coaching. Programs are designed for athletes and individuals looking to improve their health, body composition, and overall performance. All coaching is delivered through a structured online system including workouts, accountability, and nutrition guidance.",
    image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/g7khfksa_online%20strenghth%20%26%20fitness%20pic.jpeg",
    focusAreas: [
      "Functional strength and movement",
      "Mobility, agility, and durability",
      "Consistent training habits",
      "Body composition improvement",
      "Fat loss and muscle development",
      "Nutrition guidance and meal planning",
      "Sustainable health and lifestyle habits"
    ],
    pricing: {
      packages: [
        {
          name: "All-Star Package",
          duration: "6 Months",
          price: "$2,400",
          originalPrice: "$2,800",
          bestValue: true,
          purchaseLink: "https://stan.store/DillonBlueprint/p/allstar-package-",
          features: [
            "2x/week live video coaching",
            "Custom training plan",
            "Nutrition + accountability",
            "Direct access"
          ]
        },
        {
          name: "All-Star Package",
          duration: "3 Months",
          price: "$1,350",
          originalPrice: "$1,800",
          purchaseLink: "https://stan.store/DillonBlueprint/p/allstar-package--2vci1a7k",
          features: [
            "2x/week live video coaching",
            "Custom training plan",
            "Nutrition + accountability",
            "Direct access"
          ]
        },
        {
          name: "Rookie Package",
          duration: "6 Months",
          price: "$1,200",
          originalPrice: "$1,475",
          bestValue: true,
          purchaseLink: "https://stan.store/DillonBlueprint/p/rookie-package-",
          features: [
            "Custom training plan",
            "Personalized nutrition",
            "Accountability + tracking",
            "Ongoing support"
          ]
        },
        {
          name: "Rookie Package",
          duration: "3 Months",
          price: "$750",
          originalPrice: "$975",
          purchaseLink: "https://stan.store/DillonBlueprint/p/rookie-package--oxn4ylpz",
          features: [
            "Custom training plan",
            "Personalized nutrition",
            "Accountability + tracking",
            "Ongoing support"
          ]
        },
        {
          name: "Game Day Fuel",
          duration: "6 Months",
          price: "$750",
          originalPrice: "$875",
          purchaseLink: "https://stan.store/DillonBlueprint/p/game-day-fuel-6-months",
          features: [
            "Personalized meal plan",
            "Macro + portion guidance",
            "Bi-weekly accountability",
            "Ongoing support"
          ]
        },
        {
          name: "Game Day Fuel",
          duration: "3 Months",
          price: "$450",
          originalPrice: "$700",
          purchaseLink: "https://stan.store/DillonBlueprint/p/game-day-fuel-3-months-",
          features: [
            "Personalized meal plan",
            "Macro + portion guidance",
            "Bi-weekly accountability",
            "Ongoing support"
          ]
        }
      ]
    },
    cta: "Start Training"
  },
  {
    id: 3,
    title: "Mindset & Discipline Coaching",
    description: "Develop stronger habits, emotional resilience, and mental clarity through structured coaching and accountability. This program is designed for individuals navigating challenges, transitions, or personal growth while building the discipline required to move forward with confidence and direction.",
    image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/86q5ofnh_mindset%20%26%20discipline%20pic.jpeg",
    focusAreas: [
      "Discipline and habit development",
      "Emotional regulation and resilience",
      "Confidence and self-leadership",
      "Mental clarity and decision-making",
      "Personal accountability and growth",
      "Building structure and daily routines"
    ],
    programDetails: {
      structure: [
        "Weekly one-on-one coaching calls",
        "Notion-based habit and progress tracking",
        "Accountability and goal-setting system",
        "Personalized guidance and support"
      ],
      pricing: "$300 per month"
    },
    cta: "Apply For Coaching"
  }
];

export const resultsData = [
  {
    id: 1,
    title: "15% Shooting Improvement",
    description: "Athletes increase their shooting percentages through structured skill development",
    image: "https://images.unsplash.com/photo-1762860799518-546d6f2c12b2"
  },
  {
    id: 2,
    title: "Multiple Scholarship Opportunities",
    description: "Athletes guided through long-term development and exposure",
    image: "https://images.unsplash.com/photo-1762025744151-4bd3b166b271"
  },
  {
    id: 3,
    title: "Increased Confidence & Game IQ",
    description: "Better decision-making and composure on the court",
    image: "https://images.unsplash.com/photo-1585356907619-3d548694a9be"
  },
  {
    id: 4,
    title: "Strength & Fitness Gains",
    description: "Athletes build muscle, strength, and physical durability",
    image: "https://images.unsplash.com/photo-1749743823062-df9d9de55e94"
  },
  {
    id: 5,
    title: "60+ Pounds Lost",
    description: "Major fat loss transformations through disciplined training and nutrition",
    image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/hfq4mnbw_fitness%20alou.jpeg"
  },
  {
    id: 6,
    title: "Improved Discipline & Mindset",
    description: "Athletes develop stronger habits, structure, and mental focus",
    image: "https://images.unsplash.com/photo-1768349027535-da4842dab8ba"
  }
];

export const aboutData = {
  name: "Alou Dillon",
  bio: "Alou Dillon is a Basketball, Fitness & Mindset Coach dedicated to helping athletes maximize their potential. Through structured systems and performance-driven coaching, he builds stronger, faster, more confident players.",
  image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/mwx0i58x_WhatsApp%20Image%202026-03-02%20at%209.33.47%20PM.jpeg",
  socialLinks: {
    instagram: "https://instagram.com/thedillonblueprint",
    tiktok: "https://www.tiktok.com/@thedillonblueprint?_r=1&_t=ZP-94TIFvKC9EN",
    youtube: "https://youtube.com/@dillonblueprint?si=gZw5IFqVS3fu8pd8",
    facebook: "https://www.facebook.com/share/1DnGj5K2Qy/?mibextid=wwXIfr",
    twitch: "https://www.twitch.tv/thedillonblueprint"
  }
};

export const bookingData = {
  title: "Book A Session",
  description: "Work directly with Alou through private sessions, group workouts, or online consultations.",
  bookingLink: "https://dillonbluprint.setmore.com",
  options: [
    "Private basketball sessions",
    "Group workouts",
    "Online consultations",
    "Coaching calls"
  ],
  cta: "Book A Session"
};

export const clothingData = {
  title: "Shop The Brand",
  description: "Premium athletic apparel representing discipline, performance, and the athlete mindset.",
  cta: "Shop The Brand",
  shopLink: "https://the-dillon-blueprint.myshopify.com/",
  image: "https://images.unsplash.com/photo-1771308378506-7f394413342c"
};

export const ebookData = {
  title: "From Invisible to Recruitable",
  subtitle: "The Blueprint For Becoming The Type Of Player College Coaches Actually Want.",
  description: "Everything you need to know about getting recruited for basketball. Learn the strategies, systems, and mindset required to go from being overlooked to becoming a college prospect.",
  price: "$14.99",
  purchaseLink: "https://stan.store/DillonBlueprint/p/from-invisible-to-recruitable",
  image: "https://customer-assets.emergentagent.com/job_elite-coaching-15/artifacts/tp06qqcz_image.png",
  features: [
    "What college coaches actually look for (beyond stats and highlights)",
    "How to develop habits that separate you from average players",
    "The mindset to stay consistent when no one is watching",
    "Why players get overlooked and how to avoid it",
    "How to build real confidence through preparation and discipline",
    "The daily approach that turns potential into results"
  ]
};

export const communityData = {
  title: "Join The Dillon Blueprint Community",
  headline: "Your All-In-One Hub For Basketball Development, Mindset Growth, And Real Athlete Guidance",
  description: "Built from Division I and professional experience. Inside, you'll get access to exclusive training content, real insights from my journey, and a community designed to help you grow on and off the court. Whether you're just starting or chasing the next level, this is where serious athletes separate themselves.",
  tagline: "Join a space focused on discipline, consistency, and results.",
  communityLink: "https://whop.com/biz_3RVnlrxO9mKYgu",
  cta: "Join Free Community",
  image: "https://images.unsplash.com/photo-1546519638-68e109498ffc"
};

export const finalCTAData = {
  headline: "Commit To Becoming The Athlete You're Capable Of Becoming.",
  buttons: [
    { text: "Train With Me", link: "contact" },
    { text: "Book A Session", link: "booking" },
    { text: "Explore Programs", link: "services" }
  ],
  backgroundImage: "https://images.unsplash.com/photo-1751010942953-e48cb4b2ccf5"
};
